import React, { Component } from 'react'
import { Trans } from '@lingui/macro'
import { connect } from 'react-redux'
import Sticky from 'react-sticky-el'

import { Typography, ClearFilters, ConsultationLists, Spinner } from 'components'
import InfiniteScrollHoc from '../../../hoc/InfiniteScrollHoc'
import viewportHoc from '../../../hoc/viewportHoc'
import DashboardFilters from '../../../components/DashboardFilters'
import ListPlaceholder from '../../../components/ListPlaceholder/ListPlaceholder'
import Row from '../../../components/Row'
import StickyIndex from '../../../components/StickyIndex'

import ListCollator from '../../../utils/ListCollator'
import * as permissions from '../../../settings/_permissionSettings'
import { ADMINISTRATOR, PSYCHOLOGIST, PATIENT } from '../../../settings/_profileSettings'
import { SCHEDULED, ATTENDED, UNATTENDED, PROFESSIONAL_NO_SHOW, PATIENT_NO_SHOW } from '../../../settings/_scheduleStatusSettings'
import { modalTypes } from '../../../containers/ModalManager/ModalManager'
import { hasPermission } from '../../../utils/permissionHandlers'
import { getRoleFromProfile } from '../../../utils/textTransformations'
import { formatFloatToReal } from '../../Payment/utils/orderUtils'
import { getRescheduleData } from '../../../utils/rescheduleHandlers'
import { clearFilter, hideModal, setDateFilter } from '../../../redux/actions'
import * as plansFilterActions from '../../../redux/modules/plans/actions'

import {
  toString,
  getTime,
  toDayMonthYear,
  getDayName,
  isToday,
  tomorrow,
} from '../../../utils/dateTimeHandlers'
import {
  showModal,
  cleanSchedules,
  getSchedules,
} from '../../../redux/actions'
import SearchPlaceholder from '../../../components/SearchPlaceholder'
import { PatientDetailProfessionalModal } from 'containers/ModalManager/Modals/PatientDetailProfessionalModal'

class AdminScheduleList extends Component {

  state = {
    query: '',
    isLoading: true,
    openPatientDetailModal: false,
    schedules: [],
    patientData: {
      name: '',
      cpf: '',
      email: ''
    }
  };

  perPage = 10

  componentDidMount() {
    const { onCleanSchedules } = this.props

    onCleanSchedules()
    this.setState({ isLoading: true })
    this.getSchedules(this.perPage, 1)
  }

  componentDidUpdate(prevProps) {
    const { filterData, schedules } = this.props

    if (prevProps.filterData === filterData &&
      prevProps.schedules !== schedules) {
      this.setState({
        isLoading: false,
        schedules: [
          ...schedules,
        ],
      })
    }

    if (prevProps.filterData !== filterData) {
      window.scrollTo(0, 0)
      this.handleUpdateFilters()
    }

  }

  handleUpdateFilters = async () => {
    const { schedules } = this.props

    await this.setState({
      isLoading: true,
      schedules: [],
    })
    await this.props.onCleanSchedules()
    await this.getSchedules(this.perPage, 1)
    await this.setState({
      isLoading: false,
      schedules: [
        ...schedules,
      ],
    })
  }

  componentWillUnmount() {
    // Clear redux data bedore unmount
    this.props.onCleanSchedules()
    this.props.onClearFilters()
    this.props.onClearConvenios()
  }

  buildMenuList = (schedule, scheduleData) => {
    const patientData = schedule.client.person_profile.person.person_general
    const patientUsername = schedule.client.person_profile.person.username

    let menuList = []

    let cancelModalData = {
      scheduleId: schedule.id,
      requesterUsername: patientUsername,
      onSuccessClose: () => {
        this.props.onCleanSchedules()
        this.getSchedules(this.perPage, 1)
      }
    }

    const blockedModalData = {
      modalTitle: 'Desculpe, não é possível\n reagendar ou cancelar com\n menos de 24 horas do\n horário da consulta',
      titleColor: 'false',
      btnText: 'ENTENDI',
      handleClick: this.props.closeModal,
      modalChildren: (
        <div>
          <br /><Typography align="center">Esta regra existe para garantir o compromisso entre paciente e profissional quanto a programação de agendas.</Typography>
          <br /><Typography align="center">Procure reagendar / cancelar com antecedência.</Typography>
        </div>
      ),
    }

    const rescheduleData = {
      dashboard: ADMINISTRATOR,
      client: scheduleData.client,
      professional: scheduleData.professional,
      schedule: {
        ...scheduleData.scheduleData,
        date: schedule.date,
        time: schedule.time,
        isoDate: schedule.isoDate
      },
      product: scheduleData.productData,
    }

    if (schedule.status === SCHEDULED && schedule.rescheduleEnabled) {
      menuList.push({
        code: 'reschedule-appointment',
        name: 'Reagendar',
        func: () =>
          this.props.onShowModal(modalTypes.RESCHEDULE, rescheduleData),
      })
    }

    if (schedule.status !== ATTENDED && hasPermission(this.props.userPermissions, permissions.ADMIN_CANCEL_SCHEDULE)) {
      menuList.push({
        code: 'cancel-appointment',
        name: 'Cancelar',
        func: () => schedule?.cancellationEnabled
          ? this.props.onShowModal(modalTypes.ADMIN_CANCEL, cancelModalData)
          : this.props.onShowModal(modalTypes.GENERIC, blockedModalData)
      })
    }

    if ((schedule.status === ATTENDED || schedule.status === UNATTENDED || schedule.status === PROFESSIONAL_NO_SHOW || schedule.status === PATIENT_NO_SHOW) &&
      hasPermission(this.props.userPermissions, permissions.ADMIN_VIEW_SCHEDULE_LOGS)) {
      menuList.push({
        code: 'change-status',
        name: 'Detalhes da consulta',
        func: () => this.props.onShowModal(modalTypes.LOGS_VIRTUAL_ROOM, { virtualRoomHash: schedule.virtualRoomHash }),
      })
    }

    if ((schedule.status === ATTENDED || schedule.status === UNATTENDED || schedule.status === PROFESSIONAL_NO_SHOW || schedule.status === PATIENT_NO_SHOW) && hasPermission(this.props.userPermissions, permissions.ADMIN_CHANGE_SCHEDULE)) {
      menuList.push({
        code: 'change-status',
        name: 'Mudar status',
        func: () => this.props.onShowModal(modalTypes.ADMIN_CHANGE_SCHEDULE_STATUS, schedule),
      })
    }

    menuList.push({
      code: 'patient-detail',
      name: 'Detalhes do paciente',
      func: () => {
        this.setState({
          patientData: {
            name: patientData.full_name,
            email: patientUsername,
            cpf: patientData.cpf,
            phone: patientData.cellphone_number
          },
          openPatientDetailModal: true
        })
      }, 
    })

    return menuList
  };

  getSchedules = (perPage, page) => {
    const { filterData, plansFilter } = this.props
    const dateTimeNow = toString(new Date())
    
    let paramsGroup = plansFilter.actualConvenio.length ? { plan_group_code: plansFilter.actualConvenio } : {}
    let paramsPlan = plansFilter.actualConvenio.length && plansFilter.actualPlan.length ? { plan_code: plansFilter.actualPlan } : {}
    let planParams = { ...paramsGroup, ...paramsPlan }

    this.props.onGetSchedules({
      sort: filterData.isFiltering ? 'desc' : 'asc',
      query: filterData.text,
      start_date__gte: filterData.isFiltering ? filterData.startDate : dateTimeNow,
      end_date__lte: filterData.endDate,
      status_code: filterData.status,
      planParams,
      ...(perPage ? { per_page: perPage } : { per_page: 10 }),
      ...(page ? { page } : { page: 1 }),
    })
  };

  handleScheduleData = () => {
    /**
     * TODO: IMPLEMENT ROLE GROUP
     */
    const { schedules } = this.state

    const newScheduleData = schedules.map(schedule => {

      /**
       * Data retrieved directly from schedule
       */

      const isoDate = schedule.start_date
      const scheduleId = schedule.id
      const sessionId = schedule.session
      const scheduleStatus = schedule.status_code
      const cancellationEnabled = schedule.cancellation_enabled
      const rescheduleEnabled = schedule.reschedule_enabled
      const scheduleStatusName = schedule.status_name
      const consultationEvaluation = schedule.consultation_evaluation
      const planFullName = schedule.order_item.order.plan_full_name
      const guestList = schedule.guests
      const planCode = schedule.order_item.order.plan_code
      const virtualRoomHash = schedule.virtual_room_hash

      const productDuration = schedule.order_item
        .person_profile_product_appointment
        .person_profile_product.product.product_general.duration

      const productId = schedule.order_item
        .person_profile_product_appointment
        .person_profile_product.product.id

      const productCode = schedule.order_item
        .person_profile_product_appointment
        .person_profile_product.product.code

      const professionalDocumentList = schedule.order_item
        .person_profile_product_appointment
        .person_profile_product.person_profile.documents

      /**
       * Time data processed with utils
       */
      const date = toDayMonthYear(schedule.start_date)
      const dayName = getDayName(schedule.start_date)
      const dayTomorrow = tomorrow(schedule.start_date)
      const today = isToday(schedule.start_date)
      const time = getTime(schedule.start_date)
        .split(':')
        .join('h')

      const price = `R$ ${formatFloatToReal(schedule.order_item.price)}`

      /**
       * Professional data
       */
      const professionalData = schedule.guests.find(professional =>
        getRoleFromProfile(professional.person_profile.profile_code) === PSYCHOLOGIST ||
        getRoleFromProfile(professional.person_profile.profile_code) === 'PSIQ'
      )
      const professionalFirstName = professionalData.person_profile.person.person_general.first_name
      const professionalLastName = professionalData.person_profile.person.person_general.last_name
      const professionalName = `${professionalFirstName} ${professionalLastName}`

      const professionalDocument =
        professionalDocumentList.length > 0 ?
          professionalDocumentList[0].value : ''

      /**
       * Patient data
       */
      const clientData = schedule.guests.find(client =>
        getRoleFromProfile(client.person_profile.profile_code) === PATIENT
      )
      const clientFirstName = clientData.person_profile.person.person_general.first_name
      const clientLastName = clientData.person_profile.person.person_general.last_name
      const clientName = `${clientFirstName} ${clientLastName}`

      /**
       * Final object
       */
      return {
        date: date,
        today,
        dayTomorrow,
        dayName,
        time: time,
        id: scheduleId,
        session: sessionId,
        status: scheduleStatus,
        statusName: scheduleStatusName,
        cancellationEnabled,
        rescheduleEnabled,
        price: price,
        clientName: clientName,
        professionalName: professionalName,
        guestList: guestList,
        client: clientData,
        planCode: planCode,
        professional: professionalData,
        productDuration,
        productId,
        productCode,
        professionalDocument,
        isoDate,
        consultationEvaluation,
        planFullName,
        virtualRoomHash,
        startDate: schedule.start_date,
        medicalReturn: schedule.medical_return
      }
    })

    return newScheduleData
  };

  handleSchedulesGroup = () => {
    const groupedSchedules = new ListCollator()
    groupedSchedules.addItems(this.handleScheduleData())
    groupedSchedules.sortByDate()

    return groupedSchedules.sortedItems
  }

  emptyList = (
    <div className="AppointmentsList__list-empty">
      <Row justify="center" height="60vh">
        <ListPlaceholder
          iconName="AgendaTime"
          iconHeight="65px"
          iconWidth="65px"
          title={<Trans>Nenhuma consulta realizada</Trans>}
        />
      </Row>
    </div>
  )

  renderGroupByDate = (data) => (
    data.map((item, index) => {
      const labelContent = () => {
        if (this.props.filterData.status !== null) {
          return item.status.toUpperCase()
        } else {
          return isToday(item.isoDate) ? (<Trans>HOJE</Trans>) :
            tomorrow(item.isoDate) ? (<Trans>Amanhã</Trans>) :
              getDayName(item.isoDate)
        }
      }

      return (
        <Row align="center" justify="center" key={item.isoDate}>
          <StickyIndex
            textPosition='flex-start'
            barContent={labelContent()}
            barDate={item.date}
          />
          {
            item.schedules.map(schedule => {
              item.schedules = getRescheduleData(schedule)
              return (
                <Row margin="auto auto " key={schedule.id}>
                  <ConsultationLists                  
                    cardColor="#FFFFB5"
                    sessionId={schedule.session}
                    status={schedule.status}
                    iconName="MoreOptions"
                    patientName={schedule.clientName}
                    id={schedule.id}
                    psychologistName={schedule.professionalName}
                    professionalType={schedule.professional.person_profile.profile_code}
                    order={schedule.statusName}
                    sessoinId={schedule.session}
                    price={schedule.price}
                    date={schedule.date}
                    menuList={this.buildMenuList(schedule, item.schedules)}
                    avatarUrl={schedule.professionalPicture}
                    avatarSize="40px"
                    infoList={this.infoList}
                    planFullName={schedule.planFullName}
                    consultationEvaluation={schedule.consultationEvaluation}
                    virtualRoomHash={schedule.virtualRoomHash}
                    showMedicalReturnBadge={schedule.medicalReturn}
                    startDate={schedule.startDate}
                  />
                </Row>
              )
            })
          }
        </Row>
      )
    })
  );

  render() {
    const { isLoading, openPatientDetailModal, patientData } = this.state

    return (
      <div className="AppointmentsList">
        <Sticky stickyStyle={{
          backgroundColor: '#fff',
          padding: '2.5rem 0px 2rem',
          zIndex: '2',
        }}>
          <Row
            align="center"
            justify={this.props.isDesktop ? 'space-between' : 'center'}
            margin={
              this.props.isDesktop ? '3.9rem 0 2.1rem' : '2.5rem 0 1.5rem'
            }>
            <Typography className="AppointmentsList__heading" align="mcenter-dleft" Tag="h1" type="title">
              <Trans>Lista de consulta</Trans>
            </Typography>
            <div className="Dashboard-filter">
              <DashboardFilters
                hasModal
                inputPlaceholder="Buscar nome ou e-mail"
                groupCode="SCHEDULE"
                iconForAll="AllSchedules"
                showPlanFilter
              />
            </div>
          </Row>
          <ClearFilters />
        </Sticky>
        <div >
          {
            isLoading ? (<Row><Spinner height='30vh' /></Row>) :
              <InfiniteScrollHoc
                dataLength={this.props.schedules.length}
                requestMethod={(perPage, currentPage) => this.getSchedules(perPage, currentPage)}
                currentPage={this.props.schedulesPagination.page}
                perPage={10}
                totalPages={this.props.schedulesPagination.pages}
                style={{ height: '100%' }}
                emptyRender={
                  <div className="dashboard-person-list--empty">
                    <SearchPlaceholder
                      titleText='Nenhum resultado'
                      text='Refaça sua busca e seus filtros'
                    />
                  </div>
                }>
                {
                  this.renderGroupByDate(this.handleSchedulesGroup())
                }
              </InfiniteScrollHoc>
          }
        </div>
        {openPatientDetailModal && (
          <PatientDetailProfessionalModal 
            name={patientData.name}
            email={patientData.email}
            phone={patientData.phone}
            cpf={patientData.cpf}
            onClose={() => this.setState({ openPatientDetailModal: false })}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    isAuth: state.auth.isAuth,
    filterData: state.filters,
    plansFilter: state.plansFilter,
    userData: state.auth.userData,
    schedules: state.schedules.concatedSchedules,
    schedulesPagination: state.schedules.pagination,
    userPermissions: state.auth.profilePermissions,
    filterStatus: state.filterStatus.filterStatus,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCleanSchedules: () => dispatch(cleanSchedules()),
    onClearFilters: () => dispatch(clearFilter()),
    closeModal: () => dispatch(hideModal()),
    onClearConvenios: () => dispatch(plansFilterActions.clearConvenios()),
    onGetSchedules: getParams => dispatch(getSchedules(getParams)),
    onSetDateFilter: (startDate, endDate) => dispatch(setDateFilter(startDate, endDate)),
    onShowModal: (modal, data) => dispatch(showModal(modal, data)),
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(viewportHoc(AdminScheduleList))
